import { debounce } from "@utils/debounce";
import { useMainMenu } from "@features/Layout/Features/Header/Scripts/mainNavigation";
import Menu from "@features/Layout/Features/Header/Features/Menu/Scripts/menu";

enum Direction {
  Up,
  Down
}

const useHeader = (): void => {
  const element = document.querySelector('.header') as HTMLElement;
  let elementHeight: number = 0;
  let bodyRect: number = 0;
  let scrollDirection: Direction = Direction.Down;
  let scrollPosition: number = Math.ceil(window.scrollY);
  let headerHasFocus: boolean = false;

  const shouldLockHeader = () =>
    document.body.classList.contains('header-locked') ||
    document.body.hasAttribute('data-lock-header');

  const setScrollDirection = (): void => {
    if ((document.body.getBoundingClientRect()).top > bodyRect) {
      scrollDirection = Direction.Up;
    } else {
      scrollDirection = Direction.Down;
    }

    bodyRect = (document.body.getBoundingClientRect()).top;
  };

  const checkIfHeaderHasFocus = (event: FocusEvent): void => {
    if (event.target instanceof HTMLElement) {
      const elementWithFocus = event.target as HTMLElement;

      if (element?.contains(elementWithFocus)) {
        headerHasFocus = true;
      } else {
        headerHasFocus = false;
      }
    }
  };

  const toggleVisibility = (): void => {
    const currentScroll = Math.ceil(window.scrollY);
    const atBottom = currentScroll + window.innerHeight >= document.body.scrollHeight;

    if (shouldLockHeader()) {
      element?.classList.remove('header--hidden');
      scrollPosition = currentScroll;
      return;
    }

    if (scrollDirection === Direction.Down && currentScroll > scrollPosition + elementHeight && !atBottom) {
      hide();
      scrollPosition = currentScroll;
      return;
    }

    const shouldShow =
      scrollDirection === Direction.Up ||
      (scrollDirection === Direction.Down && atBottom) ||
      document.body.classList.contains('main-navigation-is-open') ||
      headerHasFocus;

    if (shouldShow && (currentScroll < scrollPosition + elementHeight || atBottom)) {
      show();
      scrollPosition = currentScroll;
    }
  };

  const hide = (): void => {
    if (!element?.classList.contains('header--hidden')) {
      element?.classList.add('header--hidden');
    }
  };

  const show = (): void => {
    if (element?.classList.contains('header--hidden')) {
      element?.classList.remove('header--hidden');
    }
  };

  const initialize = (): void => {
    if (element) {
      elementHeight = element.offsetHeight;
    }

    useMainMenu(element);
    new Menu();

    window.addEventListener('scroll', debounce(() => {
      setScrollDirection();
      toggleVisibility();
    }, 100));

    window.addEventListener('focus', (event) => {
      checkIfHeaderHasFocus(event);
      toggleVisibility();
    }, true);
  };

  initialize();
};

useHeader();